import { t } from 'ttag'

import { LocationMap } from './locationMap'

const About = ({ profile }) => {
  return (
    <div className="section" id="collegeinfo">
      <div className="row">
        <div
          itemScope=""
          itemType="http://data-vocabulary.org/Organization"
          className="col-xs-6">
          <p>
            <span className="summary-desc-name">{t`Name:`}</span>{' '}
            <span className="name" itemProp="name">
              {profile.name}
            </span>
          </p>
          <p itemProp="address" itemType="http://data-vocabulary.org/Address">
            <span className="summary-desc-name">{t`Address:`}</span>{' '}
            <div style={{ display: 'inline-block' }}>
              <span className="address" itemProp="street-address">
                {profile.address}
              </span>{' '}
              <br />
              <span className="city" itemProp="locality">
                {profile.city}
              </span>
              ,{' '}
              <span className="state" itemProp="region">
                {profile.state}
              </span>{' '}
              <span className="zipCode" itemProp="postal-code">
                {profile.zipCode}
              </span>
            </div>
          </p>
          <p>
            <span className="summary-desc-name">{t`Website:`}</span>{' '}
            <span className="url">
              <a
                href={profile.urlLink}
                target="_self"
                className="urlLink"
                itemProp="url"
                rel="nofollow">
                {profile.urlLink}
              </a>
            </span>
          </p>
          <p>
            <span className="summary-desc-name">{t`Phone:`}</span>{' '}
            <span className="phone" itemProp="tel">
              {profile.phone}
            </span>
          </p>
          <p>
            <span className="summary-desc-name">{t`Size: `}</span>{' '}
            <span className="size">{profile.size}</span>
          </p>
          <p>
            <span className="summary-desc-name">{t`Setting:`}</span>{' '}
            <span className="setting">{profile.setting}</span>
          </p>
          <p>
            <span className="summary-desc-name">{t`Sector:`}</span>{' '}
            <span className="sector">{profile.sector}</span>
          </p>
          <p>
            <span className="summary-desc-name">{t`Highest Offering:`} </span>{' '}
            <span className="degree">{profile.degree}</span>
          </p>
        </div>
        <div className="col-xs-6">
          <div className="with-dotted-border">
            <LocationMap profile={profile} />
          </div>
        </div>
        {profile.additionalLinks.map((lnk, idx) => (
          <div
            className="col-xs-12"
            style={{ paddingTop: '25px' }}
            key={`additional-key-${idx}`}>
            <a className="pull-right btn-h2more" href={lnk.link}>
              {lnk.title}
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export { About }
